<template>
    <section>
        <ob1-message-alerte
            v-if="eligibilityInfo.testChips == null"
            data-testid="eligibility-info-alert"
            :is-simple-alerte="eligibilityInfo.eligibilityMessage.simpleAlert"
            :type="formattedType"
            :title="eligibilityInfo.eligibilityMessage.title"
            :texts="eligibilityInfo.eligibilityMessage.texts"
            :with-arrow-link="withArrowLink"
            :link-href="linkHref"
            :target="linkTarget"
            :data-bs-toggle="linkDataToggle"
            :link-label="linkText"
            :with-button-from-dto="buttonFromDto"
        />

        <div v-if="eligibilityInfo.testChips" class="d-flex flex-wrap align-items-center pb-2 ps-1">
            <div class="pe-1">
                <span class="ob1-capsule ob1-capsule-reminder">
                    <span data-cs-mask v-text="eligibilityInfo.testChips.reminder" />
                    <span class="icon icon-map-pin" aria-hidden="true" />
                </span>
            </div>
            <div>
                <button
                    class="ob1-link-arrow"
                    type="submit"
                    form="tester-eligibilite"
                    name="position"
                    :value="eligibilityInfo.testChips.modifyLabel"
                    :data-oevent-category="eligibilityInfo.testChips.tag.category"
                    :data-oevent-action="eligibilityInfo.testChips.tag.action"
                    :data-oevent-label="eligibilityInfo.testChips.tag.label"
                    v-text="eligibilityInfo.testChips.modifyLabel"
                />
            </div>
        </div>

        <section v-if="eligibilityInfo.fiberPopin">
            <ob1-popin-modal
                data-testid="eligibility-info-fiber-popin"
                :popin-modal-dto="eligibilityInfo.fiberPopin.popinModal"
            >
                <FiberPopin :dto="eligibilityInfo.fiberPopin" />
            </ob1-popin-modal>
        </section>
        <section v-if="eligibilityInfo.pifInfos">
            <PifInfos data-testid="eligibility-info-pif" :pif-infos="eligibilityInfo.pifInfos" />
        </section>
        <section v-if="eligibilityInfo.pifXgsponInfos">
            <PifXgsponInfos data-testid="eligibility-info-pif-xgspon" :pif-xgspon-infos="eligibilityInfo.pifXgsponInfos" />
        </section>
    </section>
</template>

<script>

import FiberPopin from "./FiberPopin";
import PifInfos from "./PifInfos";
import PifXgsponInfos from "./PifXgsponInfos.vue";

export default {
    name: "EligibilityInfo",
    components: {
        PifXgsponInfos,
        PifInfos,
        FiberPopin
    },
    props: {
        eligibilityInfo: {type: Object, required: true}
    },
    computed: {
        formattedType() {
            return this.eligibilityInfo.eligibilityMessage.alertType.replace("alert-", "")
        },
        withArrowLink() {
            return typeof this.eligibilityInfo.eligibilityMessage.link !== 'undefined'
        },
        linkHref() {
            return this.eligibilityInfo.eligibilityMessage.link?.href
        },
        linkText() {
            return this.eligibilityInfo.eligibilityMessage.link?.text
        },
        linkTarget() {
            return this.eligibilityInfo.eligibilityMessage.link?.target
        },
        linkDataToggle() {
            return this.eligibilityInfo.eligibilityMessage.link?.dataAttributes?.dataToggle
        },
        buttonFromDto() {
            return this.eligibilityInfo.eligibilityMessage.button
        },
    }
}
</script>

<style scoped>

</style>
